// extracted by mini-css-extract-plugin
export default {"SearchBar":"SearchBar_SearchBar__T8Eao","input":"SearchBar_input__RHx7b"};